import PropTypes from 'prop-types';
// material
import { Card, Box } from '@mui/material';
//
import { Add3DElement, Map, PositionsAero } from '../../map';
// ----------------------------------------------------------------------

AerosDetailsMapDetails.propTypes = {
  aero: PropTypes.object
};

export default function AerosDetailsMapDetails({ aero }) {
  return (
    <Card>
      <Box sx={{ height: 400 }} dir="ltr">
        <Map>
          <Add3DElement />
          <PositionsAero aero={aero} />
        </Map>
      </Box>
    </Card>
  );
}
